import Signaler from '@customink/signalerjs';

import featureFlags, {
  type FlagName,
  type FlagValue,
} from '@/utils/featureFlags';

export const signaler = new Signaler(featureFlags);

export function setFeatureFlagsFromUrl(signals: typeof signaler): void {
  const query = new URLSearchParams(window.location.search);
  const selectInto = query.get('selectInto');

  if (!selectInto) return;

  selectInto.split(',').forEach((feature) => {
    const [flag, value] = feature.split(':');
    const validFlag = flag as FlagName;
    const validValue = value as FlagValue;
    if (validFlag in featureFlags) {
      signals.setFeatureFlag(validFlag, validValue);
    }
  });
}
